// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o1KWBNAB57fZVHtwDOMh{position:fixed;top:0;left:0;width:100%;height:100%;background-color:#dd4e44}`, "",{"version":3,"sources":["webpack://./src/Pages/Logout/Logout.styl"],"names":[],"mappings":"AAEA,sBACI,cAAS,CACT,KAAI,CACJ,MAAK,CACL,UAAM,CACN,WAAO,CACP,wBAAiB","sourcesContent":["@import '~assets/stylus/config/colors'\n    \n.logoutPage\n    position fixed\n    top 0\n    left 0\n    width 100%\n    height 100%\n    background-color colorRed"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textColor": `#404041`,
	"colorRed": `#dd4e44`,
	"colorPink": `#ff1493`,
	"colorBlue": `#24b2e0`,
	"colorGreen": `#65c178`,
	"colorOrange": `#fa9961`,
	"colorYellow": `#e09f34`,
	"colorPurple": `#5841ab`,
	"colorDarkBlue": `#223c75`,
	"colorBrightBlue": `#3398d9`,
	"colorGoogle": `#4285f4`,
	"logoutPage": `o1KWBNAB57fZVHtwDOMh`
};
export default ___CSS_LOADER_EXPORT___;
